import React from 'react'

function SessionConflictModal({setShowSessionPopup, handleForceLogin}) {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">

            <div className="bg-white rounded-xl shadow-lg p-6 w-[90%] max-w-md">

                <h3 className="text-lg font-semibold text-gray-800 text-center">
                    Another Session Detected
                </h3>

                <p className="text-sm text-gray-600 mt-3 text-center leading-relaxed">
                    You are already logged in on another device or browser.
                    <br />
                    Continuing will log out the other session.
                </p>

                <div className="flex gap-4 mt-6">

                    {/* Cancel */}
                    <button
                        onClick={() => setShowSessionPopup(false)}
                        className="w-full py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100"
                    >
                        Cancel
                    </button>

                    {/* Continue */}
                    <button
                        onClick={handleForceLogin}
                        className="w-full py-2 rounded-md bg-primary text-white hover:opacity-90"
                    >
                        Continue
                    </button>

                </div>
            </div>
        </div>
    )
}

export default SessionConflictModal